export default __webpack_public_path__ + "static/media/ypLogo.5dd010b6.png";